import React from 'react';
import { Link } from 'react-router-dom';

function CTA() {
  return (
    <section className="cta">
      <h2>Wie könnte Ihr Arbeitsalltag aussehen, wenn FM wirklich funktioniert?</h2>
      <p>
        In einem unverbindlichen Gespräch klären wir, wo Sie stehen – und wie Klarheit, Struktur und Verlässlichkeit wieder Einzug in Ihr Facility Management halten können.
      </p>
      <Link to="/contact" className="btn">
        Jetzt kostenfreies Beratungsgespräch vereinbaren
      </Link>
    </section>
  );
}

export default CTA;
